export default __webpack_public_path__ + "static/media/ieee.3344eebc.svg";